import React from 'react';
import { Box, Typography, Button, Dialog, DialogContent } from '@mui/material';
import { ErrorOutline as WarnIcon } from '@mui/icons-material';

// Custom confirm dialog matching the app-wide delete confirmation design
const ConfirmDeleteDialog = ({ open, onConfirm, onCancel }) => (
  <Dialog open={open} onClose={onCancel} PaperProps={{ sx: { borderRadius: 3, p: 2, maxWidth: 360, width: '100%' } }}>
    <DialogContent sx={{ textAlign: 'center', pt: 3 }}>
      <Box sx={{
        width: 72, height: 72, borderRadius: '50%',
        border: '3px solid #f5a623', display: 'flex', alignItems: 'center',
        justifyContent: 'center', mx: 'auto', mb: 2
      }}>
        <WarnIcon sx={{ fontSize: 38, color: '#f5a623' }} />
      </Box>
      <Typography variant="h6" fontWeight={700} gutterBottom>Are you sure?</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
        You won't be able to revert this!
      </Typography>
      <Button
        fullWidth
        variant="contained"
        onClick={onConfirm}
        sx={{ bgcolor: '#4caf50', '&:hover': { bgcolor: '#388e3c' }, borderRadius: 2, mb: 1.5, py: 1.2, fontWeight: 700, fontSize: '1rem' }}
      >
        Yes, delete it!
      </Button>
      <Button
        fullWidth
        variant="contained"
        onClick={onCancel}
        sx={{ bgcolor: '#e53935', '&:hover': { bgcolor: '#b71c1c' }, borderRadius: 2, py: 1.2, fontWeight: 700, fontSize: '1rem' }}
      >
        Cancel
      </Button>
    </DialogContent>
  </Dialog>
);

export default ConfirmDeleteDialog;
